import { Goal } from '../api/types';

/** Доля излишка, которую подушка получает в первую очередь (пока не заполнена). */
export const FOUNDATION_SHARE = 0.5;

/**
 * Водопад распределения суммы по целям:
 * подушка → первые 50% (с ограничением остатком), затем остальное по приоритетам,
 * излишек — обратно в подушку сверх 50%.
 */
export function suggestAllocation(goals: Goal[], total: number): Map<string, number> {
  const result = new Map<string, number>();
  let left = total;

  const foundation = goals.filter((g) => g.tier === 'foundation' && g.remaining > 0);
  if (foundation.length > 0 && left > 0) {
    let fLeft = Math.min(
      Math.round(total * FOUNDATION_SHARE),
      foundation.reduce((s, g) => s + g.remaining, 0),
    );
    for (const g of foundation) {
      const share = Math.min(g.remaining, fLeft);
      if (share > 0) {
        result.set(g.name, share);
        fLeft -= share;
        left -= share;
      }
    }
  }

  let pool = goals
    .filter((g) => g.tier !== 'foundation' && g.remaining > 0)
    .map((g) => ({ g, cap: g.remaining }));

  while (left > 0 && pool.length > 0) {
    const wsum = pool.reduce((s, x) => s + (x.g.priority ?? 3), 0);
    let used = 0;
    const next: typeof pool = [];
    for (const x of pool) {
      const share = Math.min(x.cap, Math.round((left * (x.g.priority ?? 3)) / wsum));
      if (share > 0) {
        result.set(x.g.name, (result.get(x.g.name) ?? 0) + share);
        x.cap -= share;
        used += share;
      }
      if (x.cap > 0) next.push(x);
    }
    if (used === 0) break;
    left -= used;
    pool = next;
  }

  // мечты/нужное заполнены — излишек доливаем в подушку сверх 50%
  if (left > 0) {
    for (const g of foundation) {
      const already = result.get(g.name) ?? 0;
      const more = Math.min(g.remaining - already, left);
      if (more > 0) {
        result.set(g.name, already + more);
        left -= more;
      }
    }
  }

  return result;
}
